import { ButtonDefault, ButtonRoot } from '@/components/common/Button'
import {
  FilterInputBracket,
  FilterInputBudget,
  FilterInputColorId,
  FilterInputPreconCommander,
  FilterInputTag,
  FilterInputTimeframe,
  FilterLabel,
} from '@/components/common/Filter'
import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { useBreakpoints } from '@/components/providers/BreakpointProvider'
import { usePage } from '@/components/providers/PageProvider'
import { useReduxDispatch } from '@/store/hooks'
import { viewActions } from '@/store/view'
import { getClickawayIgnoreProps } from '@/utils/clickawayUtil'
import { cn } from '@/utils/commonUtil'
import { formatFullNumber } from '@/utils/formatUtil'

import styles from './FeaturedCommonFilters.module.scss'

const CONFIG = [
  {
    filter: 'preconCommanders',
    renderInput: () => <FilterInputPreconCommander size='sm' />,
    variant: 'preconCommander',
  },
  { filter: 'colorIdMap', renderInput: () => <FilterInputColorId />, variant: 'colorId' },
  { filter: 'timeframes', renderInput: () => <FilterInputTimeframe />, variant: 'timeframe' },
  { filter: 'brackets', renderInput: () => <FilterInputBracket />, variant: 'bracket' },
  { filter: 'budgets', renderInput: () => <FilterInputBudget />, variant: 'budget' },
  { filter: 'tags', renderInput: () => <FilterInputTag size='sm' />, variant: 'tag' },
] as const

export const FeaturedCommonFilters = () => {
  const { page } = usePage()
  const dispatch = useReduxDispatch()
  const { isDesktop, loading } = useBreakpoints()

  const route = page?.route
  const hasAdvanced = !!page?.optionsFilters?.advanced
  const countAdvanced = route?.advancedFilters?.length || 0

  const onClickFilters = () => {
    if (loading) return
    if (isDesktop) dispatch(viewActions.toggleFilters())
    else dispatch(viewActions.toggleMobileStatus('filters'))
  }

  return (
    <div className={styles.container}>
      <ul className={styles.list}>
        {CONFIG.map(({ filter, renderInput, variant }) =>
          page?.optionsFilters?.[filter] ? (
            <li className={styles.item} key={variant}>
              <div className={styles.label}>
                <FilterLabel variant={variant} />
              </div>
              <div className={cn(styles.input, { styles, variant })}>{renderInput()}</div>
            </li>
          ) : null,
        )}
        {hasAdvanced && countAdvanced > 0 && (
          <li>
            <div className={styles.label}>
              <FilterLabel variant='advanced' />
            </div>
            <div className={styles.input}>
              <ButtonRoot
                className={styles.message}
                onClick={onClickFilters}
                {...getClickawayIgnoreProps(['collapse-expanded'])}
              >
                {`${formatFullNumber(countAdvanced)} Active`}
              </ButtonRoot>
            </div>
          </li>
        )}
      </ul>
      <div className={styles.buttonWrap}>
        <ButtonDefault onClick={onClickFilters} size='lg' {...getClickawayIgnoreProps(['collapse-expanded'])}>
          <IconWithLabel iconAfter='plus' iconAfterSize='sm' iconBefore='sliders'>
            Filters
          </IconWithLabel>
        </ButtonDefault>
      </div>
    </div>
  )
}
